// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__J74E0","title":"styles_title___axOv","dark":"styles_dark__A7rBg"};